module.exports = __webpack_public_path__ + "static/foryou-whole-revolution.1169a5f3.jpg";